import { render, staticRenderFns } from "./createMenuType.vue?vue&type=template&id=47605d15&"
import script from "./createMenuType.vue?vue&type=script&lang=js&"
export * from "./createMenuType.vue?vue&type=script&lang=js&"
import style0 from "./createMenuType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports